// XSRF token for browser-originated POSTs. The token always comes from the cookie at
// submit time, never from the rendered hidden input: a page served from the SEO artifact
// cache carries the renderer's token, and its visitor may have no cookie at all until
// /a/xsrf sets one.
(function (window, document) {
  'use strict';

  var COOKIE_NAMES = ['__Host-_xsrf', '_xsrf'];
  var TOKEN_URL = '/a/xsrf';
  var inflight = null;

  function token() {
    for (var i = 0; i < COOKIE_NAMES.length; i++) {
      var m = document.cookie.match(new RegExp('(?:^|;\\s*)' + COOKIE_NAMES[i] + '=([^;]+)'));
      if (m) return decodeURIComponent(m[1]);
    }
    return '';
  }

  // Tornado v2 tokens are per-render maskings of one raw value; the server compares the
  // raw value, and the checkout reuses the rendered string as its Stripe idempotency key,
  // so a rendered input that already matches the cookie is left alone.
  function raw(value) {
    var parts = String(value || '').split('|');
    if (parts.length === 1) return parts[0];
    if (parts.length !== 4 || parts[0] !== '2') return '';
    var mask = parts[1], masked = parts[2], out = '';
    for (var i = 0; i + 1 < masked.length; i += 2) {
      var byte = parseInt(masked.substr(i, 2), 16) ^ parseInt(mask.substr(((i / 2) % 4) * 2, 2), 16);
      out += ('0' + byte.toString(16)).slice(-2);
    }
    return out;
  }

  function matches(value, t) {
    return !!value && raw(value) === raw(t);
  }

  function headers(extra) {
    var h = {};
    var k;
    for (k in (extra || {})) if (Object.prototype.hasOwnProperty.call(extra, k)) h[k] = extra[k];
    var t = token();
    if (t) h['X-Xsrftoken'] = t;
    return h;
  }

  // The write counterpart of headers(): waits for the cookie instead of reading it
  // synchronously, so a request fired before /a/xsrf lands still carries a token.
  function request(url, options) {
    var opts = options || {};
    return ensure().then(function () {
      var merged = {};
      var k;
      for (k in opts) if (Object.prototype.hasOwnProperty.call(opts, k)) merged[k] = opts[k];
      merged.headers = headers(opts.headers);
      return window.fetch(url, merged);
    });
  }

  function fill(root) {
    var t = token();
    if (!t) return;
    var inputs = (root || document).querySelectorAll('input[name="_xsrf"]');
    for (var i = 0; i < inputs.length; i++) if (!matches(inputs[i].value, t)) inputs[i].value = t;
  }

  function ensure() {
    var t = token();
    if (t) return Promise.resolve(t);
    if (!inflight) {
      inflight = fetch(TOKEN_URL, { credentials: 'same-origin', cache: 'no-store' })
        .then(function () { inflight = null; fill(); return token(); },
              function () { inflight = null; return ''; });
    }
    return inflight;
  }

  function sameOrigin(form) {
    try { return new URL(form.action, window.location.href).origin === window.location.origin; }
    catch (e) { return false; }
  }

  function onSubmit(e) {
    var form = e.target;
    if (!(form instanceof HTMLFormElement) || form.method.toLowerCase() !== 'post' || !sameOrigin(form)) return;
    var t = token();
    if (!t && form.getAttribute('data-xsrf-retried') === null) {
      e.preventDefault();
      e.stopImmediatePropagation();
      var submitter = e.submitter;
      ensure().then(function () {
        form.setAttribute('data-xsrf-retried', '');
        if (form.requestSubmit) form.requestSubmit(submitter || undefined); else form.submit();
      });
      return;
    }
    if (!t) return;
    var input = form.querySelector('input[name="_xsrf"]');
    if (!input) {
      input = document.createElement('input');
      input.type = 'hidden';
      input.name = '_xsrf';
      form.appendChild(input);
    }
    if (!matches(input.value, t)) input.value = t;
  }

  function init() {
    if (token()) fill(); else ensure();
  }

  document.addEventListener('submit', onSubmit, true);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();

  window.JN = window.JN || {};
  window.JN.xsrf = { token: token, headers: headers, fill: fill, ensure: ensure, fetch: request };
})(window, document);
